/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

/* utilities */
import {parseDataToProps} from 'js/utilities';

const sliders = Array.from(document.querySelectorAll('[data-credit-slider]'));
if (sliders.length) {
    import(/* webpackChunkName: "CreditSlider" */ './credit-slider').then(({ default: CreditSlider }) => {
        sliders.forEach((node) => createRoot(node).render(<CreditSlider {...parseDataToProps(node.dataset)}/>));
    });
}
